"use client";
import { ReactNode } from "react";
import styled from "styled-components";
import { PopoverOptions, usePopover } from "../../hooks/usePopover";
import { CloseIcon } from "../../icons/CloseIcon";
import { StyledBackdrop, SvgStyle } from "../../styles/globalsStyles";

const _StyledPopover = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 1rem;
  /* min-width: 400px; */
  min-height: 300px;
  max-height: 95%;
  max-width: 90vw;
  overflow: auto;
  z-index: 9999;
  border-radius: 20px;
`;
const ChildrenWrapper = styled.div`
  height: max-content;
`;

export const StyledPopover = ({
  children
}: // options
{
  children: ReactNode;
  options?: PopoverOptions;
}) => {
  const { hidePopover } = usePopover();
  // const ref = useOutsideClick(hidePopover);
  return (
    <StyledBackdrop>
      <_StyledPopover>
        <StyledCloseIcon onClick={hidePopover} />
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </_StyledPopover>
    </StyledBackdrop>
  );
};

const StyledCloseIcon = styled(CloseIcon)`
  /* position: absolute; */
  ${SvgStyle}
`;
